export default function Home() {
    return (
        <div className="main-home-container">
            <div className="home-container">
                <h1 className='welcome'>Welcome to Art Break!</h1>
                    <p className='welcome-par'>Need an art break? Head to the gallery to view artwork from the Harvard Art Museums collection or visit the art studio and test your drawing skills.
                    </p>
                    <div className='home-img-container'>
                        <div className='grid-container-one'>
                            <div className='one'></div>
                            <div className='two'></div>
                            <div className='three'></div>
                            <div className='four'></div>
                            <div className='five'></div>
                            <div className='six'></div>
                            <div className='seven'></div>
                            <div className='eight'></div>
                            <div className='nine'></div>
                        </div>
                        <div className='grid-container-two'>
                            <div className='one-t'></div>
                            <div className='two-t'></div>
                            <div className='three-t'></div>
                            <div className='four-t'></div>
                            <div className='five-t'></div>
                            <div className='six-t'></div>
                            <div className='seven-t'></div>
                            <div className='eight-t'></div>
                            <div className='nine-t'></div>
                            <div className='ten-t'></div>
                        </div>
                    </div>
            </div>
        </div>
    )
}